module.exports = __webpack_public_path__ + "images/stickers/pete-happy.e4790e5066725b5d4155.png";